module.exports = __webpack_public_path__ + "34bc775d/img/mini-logo.18817ee5.svg";